export default function cloneObject(obj) {
  var str = JSON.stringify(obj);
  return JSON.parse(str);
}